import React, { useEffect } from 'react'

const CCPANotice = () => {
  useEffect(() => {
    document.title = 'California Consumer Privacy Act Notice - Flux App'
  }, [])

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '40px 20px', fontFamily: 'system-ui, -apple-system, sans-serif', color: '#333', lineHeight: 1.8 }}>
      <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8, textAlign: 'center' }}>California Consumer Privacy Act Notice</h1>
      <p style={{ color: '#888', marginBottom: 32, textAlign: 'left' }}>Last updated: </p>

      <p>
        This California Consumer Privacy Act Notice ("Notice") provides additional information to California residents whose personal
        information is processed by Hangzhou Furui Technology Co., Ltd. ("Flux", "we", "our", or "us") pursuant to the California Consumer
        Privacy Act ("CCPA"). If you are not a California resident, this Notice does not apply to you. Please visit the Privacy Policy for
        more information.
      </p>

      <h2 style={sectionTitle}>Categories of Personal Information Collected and Disclosed</h2>
      <p>
        During the preceding 12 months, Flux has collected the following categories of personal information that are processed pursuant to
        the CCPA:
      </p>
      <ul style={listStyle}>
        <li>Identifiers, such as your contact information and online account information;</li>
        <li>Internet and electronic network activity information, such as information about your interactions with Flux App;</li>
        <li>Your Inputs and the Outputs you receive;</li>
        <li>Geolocation data; and</li>
        <li>Financial information and other information as described above that may be considered personal information under the CCPA.</li>
      </ul>
      <p>
        Please see the "What Information We Collect" section of the Privacy Policy for more information about our information collection
        practices.
      </p>
      <p>
        We do not and will not "sell" personal information for purposes of the CCPA. As set forth in the Privacy Policy, we disclose personal
        information to third parties for business purposes, including but not limited to advertising, marketing, and other services performed
        on our behalf, to protect against fraud and malicious activity, and for other business purposes described in the Privacy Policy.
        During the preceding 12 months, we have disclosed each of the above-listed categories of personal information for such business
        purposes. In addition, your information may be accessible to third parties with whom you interact or direct us to share your
        information through our services.
      </p>

      <h2 style={sectionTitle}>CCPA Rights</h2>
      <p>
        The CCPA allows California residents to request that a business that collects consumers' personal information give consumers access,
        upon a verifiable consumer request, in a portable and (if technically feasible) readily usable form, to the specific pieces and
        categories of personal information that the business has collected about the consumer, the categories of sources for that information,
        the business or commercial purposes for collecting the information, and the categories of third parties with which the information was
        shared. California residents also have the right to submit a request for deletion of personal information under certain circumstances,
        although there may be legal or other reasons that Flux must retain your information consistent with California law. We will not
        discriminate against you for exercising your rights and choices, although some of the functionality and features available to you may
        change or no longer be available to you. Any difference in the services is related to the value provided.
      </p>
      <p>
        Please submit your request by emailing our Data Protection Officer at{' '}
        <a href="mailto:appworks.ai@gmail.com" style={linkStyle}>appworks.ai@gmail.com</a>.
      </p>
      <p>
        Once we receive your request, we may verify it by requesting information sufficient to confirm your identity. If you would like to
        use an authorized agent registered with the California Secretary of State to exercise your rights, we may request evidence that you
        have provided such agent with power of attorney or that the agent otherwise has valid written authority to submit requests to exercise
        rights on your behalf. We reserve the right to deny requests in certain circumstances, such as where we have a reasonable belief that
        the request is fraudulent.
      </p>

      <div style={{ height: 60 }} />
    </div>
  )
}

const sectionTitle = { fontSize: 20, fontWeight: 700, marginTop: 40, marginBottom: 12, color: '#111' }
const listStyle = { paddingLeft: 24, marginBottom: 16 }
const linkStyle = { color: '#7c3aed', textDecoration: 'underline' }

export default CCPANotice
